export type StepRemovalReconnectEdge = {
  source?: any;
  target?: any;
  sourceHandle?: any;
  targetHandle?: any;
  hidden?: any;
  data?: any;
  type?: string;
};

const normalizeKey = (value: any): string =>
  value !== undefined && value !== null ? String(value) : "";

const parseEdgeData = (edge: StepRemovalReconnectEdge): any => {
  const { data } = edge || {};
  if (!data) return {};
  if (typeof data === "object") return data;
  if (typeof data === "string") {
    try {
      return JSON.parse(data);
    } catch {
      return {};
    }
  }
  return {};
};

const isHiddenEdge = (edge: StepRemovalReconnectEdge): boolean => {
  if (!edge) return true;
  if (edge.hidden) return true;
  if (edge.type === "hidden" || edge.type === "serialized-hidden") {
    return true;
  }
  return Boolean(parseEdgeData(edge).hidden);
};

const handleIncludes = (value: any, handleName: string): boolean =>
  normalizeKey(value).includes(`__handle-${handleName}`);

const isLoopBackEdge = (edge: StepRemovalReconnectEdge): boolean =>
  handleIncludes(edge?.sourceHandle, "top") &&
  handleIncludes(edge?.targetHandle, "top");

export function isVisibleStepRemovalReconnectEdge(
  edge: StepRemovalReconnectEdge | undefined
): boolean {
  return Boolean(edge && !isHiddenEdge(edge) && !isLoopBackEdge(edge));
}

export function isVisibleIncomingStepEdge(
  edge: StepRemovalReconnectEdge | undefined,
  targetOrigId: any
): boolean {
  const target = normalizeKey(targetOrigId);
  if (!target || !isVisibleStepRemovalReconnectEdge(edge)) return false;

  return (
    normalizeKey(edge?.target) === target &&
    handleIncludes(edge?.targetHandle, "left")
  );
}

export function getVisibleOutgoingStepTargetOrigId(
  edges: StepRemovalReconnectEdge[] | undefined,
  sourceOrigId: any
): string | null {
  const source = normalizeKey(sourceOrigId);
  if (!source || !Array.isArray(edges)) return null;

  const outgoingEdge = edges.find((edge) => {
    if (!isVisibleStepRemovalReconnectEdge(edge)) return false;
    if (normalizeKey(edge.source) !== source) return false;
    if (!handleIncludes(edge.sourceHandle, "right")) return false;
    if (!handleIncludes(edge.targetHandle, "left")) return false;

    const target = normalizeKey(edge.target);
    return Boolean(target && target !== source);
  });

  const target = normalizeKey(outgoingEdge?.target);
  return target || null;
}

export function resolveStepRemovalReconnectTarget({
  outgoingEdgeTargetOrigId,
}: {
  outgoingEdgeTargetOrigId?: any;
}): string | null {
  return normalizeKey(outgoingEdgeTargetOrigId) || null;
}
